<appTable v-if="shouldRenderConfig" :tableName="name"  v-bind:tableClass="getClassName">
    <appSummary></appSummary>
</appTable>
